import React from 'react'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { IconTitleDescriptionItemType, ThemeModeType } from '@application/Types/ComponentTypes'

import { Icon, Item, ItemDescription, ItemTitle, ReadMore } from './IconTitleDescriptionItem.styled'

type IconTitleDescriptionItemProps = {
    item: IconTitleDescriptionItemType
    mode: ThemeModeType
}

export const IconTitleDescriptionItem = ({ item, mode }: IconTitleDescriptionItemProps): JSX.Element => {
    return (
        <Item $mode={mode}>
            {item.image && <Icon image={item.image} imageAnimation={item.imageAnimation} />}
            <ItemTitle>{item.title}</ItemTitle>
            {item.description && <ItemDescription>{item.description}</ItemDescription>}
            {item.link && item.linkLabel && (
                <ReadMore to={item.link}>
                    <span>{item.linkLabel}</span>
                    <ArrowDirectionIcon colorCode={mode === 'Dark' ? 'white' : 'g600'} />
                </ReadMore>
            )}
        </Item>
    )
}
